import { COMPONENT_VALUE_TYPES as types, HEIGHT_VH } from 'shared/constants';

const propsSchema = [
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'sub_title',
    label: 'Subtitle',
    type: types.TEXT,
  },
  {
    key: 'app_links',
    label: 'App Download Links',
    type: types.ARRAY,
    children: [
      {
        key: 'qr_img',
        label: 'QR Code image',
        type: types.TEXT,
      },
      {
        key: 'app_store_img',
        label: 'App Store Image',
        type: types.TEXT,
      },
      {
        key: 'app_store_link',
        label: 'Link to app store',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'background_color',
    label: 'Background Color',
    type: types.COLOR_PICKER,
  },
  {
    key: 'text_color',
    label: 'Text Color',
    type: types.COLOR_PICKER,
  },
  {
    key: 'height',
    label: 'Widget Height',
    type: types.OBJECT,
    children: [
      {
        key: 'desktop_height',
        label: 'Desktop (vh):',
        type: types.ENUM,
        options: HEIGHT_VH,
      },
      {
        key: 'tablet_height',
        label: 'Tablet (vh):',
        type: types.ENUM,
        options: HEIGHT_VH,
      },
      {
        key: 'mobile_height',
        label: 'Mobile (vh):',
        type: types.ENUM,
        options: HEIGHT_VH,
      },
    ],
  },
  {
    key: 'img_sizes',
    label: 'Image Sizes (Desktop Only)',
    type: types.OBJECT,
    children: [
      {
        key: 'qr_height',
        label: 'QR CODE HEIGHT (px, em, %)',
        type: types.TEXT,
      },
      {
        key: 'qr_width',
        label: 'QR CODE WIDTH (px, em, %)',
        type: types.TEXT,
      },
      {
        key: 'app_store_height',
        label: 'APP STORE HEIGHT (px, em, %)',
        type: types.TEXT,
      },
      {
        key: 'app_store_width',
        label: 'APP STORE WIDTH (px, em, %)',
        type: types.TEXT,
      },
    ],
  },
  {
    key: 'hide_qr_codes_on_mobile',
    label: 'Hide QR codes on mobile',
    type: types.BOOLEAN,
  },
];

const defaultProps = {
  title: 'STAY CONNECTED WITH US',
  sub_title: 'Download the FF Intelligent App',
  app_links: [
    {
      app_store_img:
        'https://genesis-cdn.ff.com/assets/pages/homepage/download-on-the-app-store-badge.png',
      app_store_link:
        'https://apps.apple.com/us/app/faraday-future/id1454187098',
      qr_img:
        'https://genesis-cdn.ff.com/assets/pages/homepage/appleprodus.png',
    },
    {
      app_store_img:
        'https://genesis-cdn.ff.com/assets/pages/homepage/gplay-app-store-badge.png',
      app_store_link:
        'https://play.google.com/store/apps/details?id=com.faradayfuture.online',
      qr_img:
        'https://genesis-cdn.ff.com/assets/pages/homepage/androidprodus.png',
    },
  ],
  background_color: '#FFFFFF',
  text_color: '#000000',
  height: {
    desktop_height: '30',
    tablet_height: '20',
    mobile_height: '15'
  },
  img_sizes: {
    app_store_height: '100%',
    app_store_width: '170px',
    qr_height: '170px',
    qr_width: '170px'
  },
  hide_qr_codes_on_mobile: true,
};

export default {
  title: 'QRColumns',
  id: 'QRColumns',
  propsSchema,
  defaultProps,
};
